import { useState } from "react";
import { toast } from "sonner";
import axios from "axios";
import { Eye, EyeOff } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const MyCodeTab = ({ getAuthHeaders }) => {
  const [newCode, setNewCode] = useState("");
  const [showCode, setShowCode] = useState(false);
  const [changingCode, setChangingCode] = useState(false);

  const changeMyCode = async (e) => {
    e.preventDefault();
    if (newCode.trim().length < 4) { toast.error("Koden skal være mindst 4 tegn"); return; }
    setChangingCode(true);
    try {
      await axios.put(`${API}/member-codes/my-code`, { new_code: newCode.trim() }, { headers: getAuthHeaders() });
      toast.success("Din kode er opdateret!");
      setNewCode("");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Kunne ikke ændre kode");
    } finally {
      setChangingCode(false);
    }
  };

  return (
    <div className="max-w-lg">
      <h2 className="text-2xl font-['Oswald'] font-bold text-white mb-4">MIN KODE</h2>
      <p className="text-gray-400 mb-6">Her kan du ændre din personlige adgangskode.</p>
      <form onSubmit={changeMyCode} className="mc-card p-6 space-y-4">
        <div>
          <label className="block text-sm text-gray-400 mb-2">Ny personlig kode (mindst 4 tegn)</label>
          <div className="relative">
            <input
              type={showCode ? "text" : "password"}
              value={newCode}
              onChange={(e) => setNewCode(e.target.value.toUpperCase())}
              className="mc-input w-full pr-12 text-center text-lg tracking-widest font-mono"
              placeholder="NY KODE"
              data-testid="new-code-input"
            />
            <button type="button" onClick={() => setShowCode(!showCode)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300">
              {showCode ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
            </button>
          </div>
        </div>
        <button type="submit" disabled={changingCode || newCode.trim().length < 4}
          className="w-full chrome-btn py-3 rounded-xl font-['Oswald'] uppercase tracking-wider disabled:opacity-50"
          data-testid="change-code-submit">
          {changingCode ? "Gemmer..." : "Skift kode"}
        </button>
      </form>
    </div>
  );
};

export default MyCodeTab;
